/**
 *
 * Delete Modal component
 *
 * @evaluation good refactor
 * @category complex ui
 * @todo Text parameters should not be fixed, but be given as parameters to the component
 *
 */
import { Button, Modal } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import * as registry from "@qpr/client-api-registry";
import { t } from "i18next";
import React from "react";
import { useAppContext } from "./../../context/AppCtxProvider";
import { makeThemedStyles } from "./../../viewcomponents/utils";
const useStyles = (rtl: boolean) =>
  makeThemedStyles("", (theme) => ({
    modalContainer: {
      position: "relative",
      top: "20vh",
      left: "50%",
      transform: "translateX(-50%)",
      width: "88.342em",
      height: "41.6em",
      borderRadius: "0.914em",
      background: "#ffffff",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    deleteIcon: {
      width: "6.628em",
      height: "6.628em",
      background: "rgba(189, 41, 44, 0.15)",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      paddingTop: "2.628em",
      marginTop: "6.742em",
      marginBottom: "2.742em",
    },
    deleteText: {
      fontFamily: "Dubai",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "2.285em",
      lineHeight: "1.4em",
      color: "rgb(76,81,87)",
      marginBottom: "1.05em",
    },
    deleteInfo: {
      padding: "1.428em 0",
      fontFamily: "Dubai",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "1.6em",
      lineHeight: "1.428em",
      borderTop: "0.0714em solid rgba(151, 151, 151, 0.17)",
      borderBottom: "0.0714em solid rgba(151, 151, 151, 0.17)",
      marginBottom: "1.714em",
      width: "calc(100% - 4.571em)",
      textAlign: "center",
    },
    deleteButtons: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "38.285em",
      fontFamily: "Dubai",
      fontStyle: "normal",
      flexDirection: rtl ? "row-reverse" : "row",
    },
    rejectDelete: {
      MixBlendMode: "normal",
      border: "0.0714em solid rgba(151, 151, 151, 0.23)",
      borderRadius: "12.714em",
      width: "11.071em",
      height: "2.857em",
      color: "#4C5157",
      textTransform: "none",
      fontWeight: 400,
      fontSize: "1.6em",
      lineHeight: "1.428em",
      letterSpacing: "0.003125em",
      "&:hover": {
        color: "#4C5157",
        background: "transparent",
      },
    },
    cDelete: {
      width: "11.071em",
      height: "2.857em",
      background: "#BD292C",
      color: "#ffffff",
      borderRadius: "12.714em",
      textTransform: "none",
      fontWeight: 400,
      fontSize: "1.6em",
      lineHeight: "1.428em",
      letterSpacing: "0.003125em",
      "&:hover": {
        color: "#ffffff",
        background: "#BD292C",
      },
    },
    closeButton: {
      position: "absolute",
      top: "2.742em",
      [rtl ? "left" : "right"]: "2.742em",
      "&:hover": {
        background: "transparent",
      },
    },
    subTitle1: {
      marginTop: 0,
      marginBottom: "0.5em",
    },
  }));
type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
  handleDelete?: () => void;
  title?: string;
  subTitle?: string;
  subTitle1?: string;
  cancelButtonCaption?: string;
  okButtonCaption?: string;
};
const DeleteModal = (props: Props) => {
  const {
    open,
    setOpen,
    title = t("Delete Message"),
    subTitle = "Deleting the message will permanently remove it from the thread",
    subTitle1,
    cancelButtonCaption,
    okButtonCaption,
  } = props;
  const rtl = useAppContext((s) => s.rtl);
  const styles = useStyles(rtl)();
  const handleDelete = () => {
    if (props.handleDelete) {
      return props.handleDelete();
    }
    const evt = new Event("deleteComment");
    window.dispatchEvent(evt);
    setOpen(false);
  };
  const CloseButton = registry.getSvg("CloseButton");
  const Delete = registry.getSvg("Delete");
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Fade timeout={400} in={props.open}>
        <div className={styles.modalContainer} {...props}>
          <Button
            className={styles.closeButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseButton />
          </Button>
          <div className={styles.deleteIcon}>
            <Delete />
          </div>
          <div className={styles.deleteText}>{title}</div>
          <div className={styles.deleteInfo}>
            {subTitle1 && <p className={styles.subTitle1}>{subTitle1}</p>}
            {t(subTitle)}
          </div>
          <div className={styles.deleteButtons}>
            <Button
              className={styles.rejectDelete}
              onClick={() => {
                setOpen(false);
              }}
            >
              {t(cancelButtonCaption || "No, Keep It")}
            </Button>
            <Button className={styles.cDelete} onClick={handleDelete}>
              {t(okButtonCaption || "Yes, Delete It")}
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};
export default DeleteModal;
